module.exports = __webpack_public_path__ + "img/bandeira-visa.38ebbc66.svg";